import styled, { keyframes } from "styled-components";

const pulseAnimationVariation = keyframes`
  0% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 rgba(42, 250, 165, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 20px rgba(42, 250, 165, 0);
  }
  100% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 rgba(42, 250, 165, 0);
  }
`;

export const PulseElementVariation = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
  animation: ${pulseAnimationVariation} 2s ease-in-out infinite;
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 20px rgba(255, 0, 0, 0);
  }
  100% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
`;

export const PulseElement = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
  animation: ${pulseAnimation} 2s ease-in-out infinite;
`;

export const Popover = styled.div`
  position: absolute;
  text-align: justify;
  right: -130%;
  transform: translateX(-50%);
  width: 200px;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: visibility 0.3s, opacity 0.3s;
`;

export const Container = styled.div`
  background-image: url("./images/backGroud_gray.svg");
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 500px;
  width: 100%;
`;

export const ContainerCard = styled.div`
  background-color: #fff;
  border-radius: 20px;
  color: #fa821f;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 230px;
  margin: 50px auto;
  position: relative;
  width: 230px;
`;

export const ImgCard = styled.img`
  height: 145px;
  margin: 45px 30px;
  position: absolute;
`;

export const LoanImgCard = styled(ImgCard)`
  height: 145px;
  margin: 45px 20px;
`;

export const Paragraph = styled.p`
 
  font-size: 22px;
  font-weight: bolder;
  margin: 10px auto;
  width: 100%;
  text-align: center;
`;

export const FooterPrice = styled.div`
  align-items: center;
  background-color: #666;
  border-radius: 25px;
  color: #2afaa5;
  height: 40px;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  width: 100%;
  input {
  background-color: #666;
  font-size: 16px;
  font-weight: bold;
  color: #2afaa5;
  width: 100%;
  text-align: end;

  ::placeholder {
    color: #2afaa5;
  }
  }
  img {
    height: 80%;
    margin-left: -12px;
  }
`;

export const ImgFooter = styled.img`
  width: 300px;
  margin:0 auto 50px;
`;
